import {sendRequestAuth} from 'api/api'
import config from 'config'
import useAlert from 'hook/useAlert'
import {useContext, useState} from 'react'
import {InvoiceContext} from '../provider/_context'
import {invoiceActions} from '../provider/_reducer'
import useInvoiceFilterForm from './useInvoiceFilterForm'

const useInvoiceTHead = () => {
  const {showAlert} = useAlert()
  const {functions} = useInvoiceFilterForm()

  const {pageState, pageDispatch} = useContext(InvoiceContext)
  const {notifications, filter, table} = pageState

  const [statusUpdateErrList, setStatusErrList] = useState([])
  const [
    shouldOpenUpdateStatusFailedModal,
    setShouldOpenUpdateStatusFailedModal,
  ] = useState(false)
  const [globalLoading, setGlobalLoading] = useState(false)

  const displayList = table.display.list.filter(
    item => item.shipping_status_id !== '15',
  )
  const selectedList = table.selected.list.filter(
    item => item.shipping_status_id !== '15',
  )

  // CHECKBOX
  const shouldActiveCheckbox = selectedList.length > 0

  const isActive =
    displayList.length <= 0
      ? false
      : selectedList.length < displayList.length
      ? false
      : !!!displayList.find(
          item => !!!selectedList.find(find => find?.id === item?.id),
        )

  const handleCheckboxChange = () => {
    let newSelectedList = []
    if (isActive) {
      newSelectedList = selectedList.filter(
        item => !!!displayList.find(find => find?.id === item?.id),
      )
    } else {
      let addingList = []
      displayList.forEach(item => {
        if (item?.shipping_status_id === '15') return
        if (!!!selectedList.find(find => find?.id === item?.id))
          addingList = [...addingList, item]
      })
      newSelectedList = [...selectedList, ...addingList]
    }

    pageDispatch({
      type: invoiceActions.TABLE_SELECTED_LIST_UPDATE,
      payload: {selected: {list: newSelectedList}},
    })
  }

  // SELECTED ACTION DROPDOWN
  const [shouldOpenSelectedActionMenu, setShouldOpenSelectedActionMenu] =
    useState(false)

  const fetchUpdateInvoiceStatus = async (idList, status) => {
    const response = await sendRequestAuth(
      'post',
      `${config.API}/invoice/cancel-delivery`,
      JSON.stringify({
        invoice_ids: idList,
        status: status,
      }),
    )
    if (response?.data?.success) {
      showAlert({content: 'Cập nhật trạng thái thành công', type: 'success'})
      functions.fetchUpdateData()
    } else {
      const hasError = Array.isArray(response?.data?.errors?.details)

      pageDispatch({
        type: invoiceActions.NOTIFICATIONS_LIST_UPDATE,
        payload: {
          notifications: {
            list: hasError
              ? response.data.errors.details.filter(item => !!!item?.success)
              : [],
          },
        },
      })

      if (hasError && response?.data?.errors?.details?.find(x => x.success)) {
        functions.fetchUpdateData()
      }
    }

    pageDispatch({
      type: invoiceActions.TABLE_SELECTED_LIST_UPDATE,
      payload: {
        selected: {
          list: [],
        },
      },
    })

    return response
  }

  const handleBulkInvoiceApply = statusValue => {
    setGlobalLoading(true)

    const response = fetchUpdateInvoiceStatus(
      selectedList.map(item => item.id),
      statusValue,
    )

    response.then(() => {
      setGlobalLoading(false)
    })

    return response
  }

  const handleNotifcationDelete = () => {
    pageDispatch({
      type: invoiceActions.NOTIFICATIONS_LIST_UPDATE,
      payload: {
        notifications: {
          list: [],
        },
      },
    })
  }

  return {
    globalLoading: {value: globalLoading, set: setGlobalLoading},
    checkbox: {
      checked: shouldActiveCheckbox,
      onClick: handleCheckboxChange,
    },
    modal: {
      updateStatus: {
        data: statusUpdateErrList,
        open: !!(
          shouldOpenUpdateStatusFailedModal && statusUpdateErrList.length > 0
        ),
        onToggle: setShouldOpenUpdateStatusFailedModal,
      },
    },
    notifications: {
      delete: handleNotifcationDelete,
    },
    selected: {
      actionMenu: {
        open: shouldOpenSelectedActionMenu,
        onToggle: setShouldOpenSelectedActionMenu,
        actions: [
          () => handleBulkInvoiceApply(1),
          () => handleBulkInvoiceApply(7),
          () => handleBulkInvoiceApply(15),
        ],
      },
      list: selectedList,
    },
  }
}

export default useInvoiceTHead
